(function () {
  var api;
  function loadAPI() {
    if (window.YT && window.YT.Player) return Promise.resolve();
    if (!api) api = new Promise(function (resolve) {
      var previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (previous) previous();
        resolve();
      };
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        var script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(script);
      }
    });
    return api;
  }
  function init() {
    var root = document.getElementById('LucceGuide-carat');
    if (!root && location.pathname.indexOf('/pages/carat-size-guide') !== -1) root = document.getElementById('MainContent');
    if (!root) return;
    root.querySelectorAll('iframe').forEach(function (iframe) {
      var match = (iframe.getAttribute('src') || '').match(/https:\/\/(?:www\.)?youtube(?:-nocookie)?\.com\/embed\/([\w-]+)/);
      if (!match) return;
      var videoId = match[1];
      var wrapper = document.createElement('div');
      wrapper.className = 'lucce-carat-guide-video';
      var width = Number(iframe.getAttribute('width'));
      var height = Number(iframe.getAttribute('height'));
      if (width > 0 && height > 0) wrapper.style.aspectRatio = width + ' / ' + height;
      var target = document.createElement('div');
      var preview = document.createElement('button');
      preview.type = 'button';
      preview.setAttribute('aria-label', iframe.title || root.getAttribute('data-guide-label') || document.title);
      var image = document.createElement('img');
      image.alt = '';
      image.src = 'https://i.ytimg.com/vi/' + videoId + '/maxresdefault.jpg';
      function fallback() {
        if (image.src.indexOf('maxresdefault') !== -1) image.src = 'https://i.ytimg.com/vi/' + videoId + '/hqdefault.jpg';
      }
      image.addEventListener('error', fallback);
      image.addEventListener('load', function () { if (image.naturalWidth < 200) fallback(); });
      preview.appendChild(image);
      wrapper.appendChild(target);
      wrapper.appendChild(preview);
      if (iframe.parentElement.classList.contains('video-wrapper')) iframe.parentElement.replaceWith(wrapper);
      else iframe.replaceWith(wrapper);
      var player, ready = false, starting = false, visible = false, manual = false;
      function start() {
        if (player) {
          if (ready) { player.mute(); player.playVideo(); }
          return;
        }
        if (starting) return;
        starting = true;
        loadAPI().then(function () {
          player = new window.YT.Player(target, {
            videoId: videoId,
            playerVars: { playsinline: 1, controls: 1, loop: 1, playlist: videoId, origin: location.origin },
            events: {
              onReady: function (event) {
                ready = true;
                event.target.mute();
                if (visible || manual) event.target.playVideo();
              },
              onStateChange: function (event) {
                wrapper.dataset.playbackState = String(event.data);
                if (event.data === 1) preview.hidden = true;
              },
              onError: function () { preview.hidden = true; }
            }
          });
        });
      }
      preview.addEventListener('click', function () { manual = true; start(); });
      if (window.IntersectionObserver) new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
        if (visible && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
        else if (ready) player.pauseVideo();
      }, { threshold: [0, 0.15] }).observe(wrapper);
      var dialog = wrapper.closest('dialog');
      if (dialog) dialog.addEventListener('close', function () { visible = false; manual = false; if (ready) player.pauseVideo(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
